// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

/**
 * Vyjmenované hodnoty pro forma doručení.
 */

export const ADR = 'ADR';

export const POB = 'POB';

export const PBX = 'PBX';

export const VSE = 'VSE';

/**
 * Seznam všech hodnot.
 */
export const values = [
    ADR,
    POB,
    PBX,
    VSE
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [ADR]: {caption: ''},
    [POB]: {caption: ''},
    [PBX]: {caption: ''},
    [VSE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}